import React from "react";
import Image from 'assets/img/apple-icon.png'
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-kit-react/views/componentsSections/basicsStyle.js";

const useStyles = makeStyles(styles);

export default function Brand(props) {
  const classes = useStyles();

  if (!props.shrink)
  // return (
  //     <div style={{ minWidth: '300px' }}>
  //       <table>
  //         <tr>
  //           <td rowspan="2">
  //             <img alt="icon" src={Image} className={classes.icons} style={{ height: '80px', width: '80px', paddingRight: '10px' }} />
  //           </td>
  //           <td style={{ paddingTop: '10px' }}><b>जिल्ला समन्वय समितिको कार्यालय</b></td>
  //         </tr>
  //         <tr>
  //           <td><p>भक्तपुर, नेपाल</p></td>
  //         </tr>
  //       </table>
  //     </div>
  // )
  return (
      <div style={{ minWidth: '300px' }}>
        <table>
          <tr>
            <td>
              <img alt="icon" src={Image} className={classes.icons} style={{ height: '60px', width: '60px' }} />
            </td>
            <td style={{ padding: '7px' }}><div>जिल्ला समन्वय समिति, भक्तपुर</div><div style={{ fontSize: '13px', marginTop: '-10px' }}>विद्युतीय सूचना केन्द्र</div></td>
          </tr>
        </table>
      </div>
  )
  else return <div/>
}
